// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3J9xW","row":"ProcedureTreatmentSummary_row__2YpnV"};